import { clearAccountStatus, clearWebSocketAuthToken, setWebSocketAuthToken } from '@shared/utils'
import { CfdPush } from '@features/push'
import { useAuthStore } from './authStore'

export interface ResolvedAuthSession {
  userId: string
  svrId: string
  brokerId: string
  accessToken: string
}

const getSessionPayload = (data: AuthSessionResponse): AuthSessionPayload => {
  return data.session ?? {}
}

export const resolveAuthSession = (data: AuthSessionResponse): ResolvedAuthSession | null => {
  if (data.code !== undefined && data.code !== 200) return null

  const payload = getSessionPayload(data)
  const userId = payload.userId ?? ''
  if (!userId) return null

  return {
    userId: String(userId),
    svrId: String(payload.accId ?? ''),
    brokerId: String(payload.svrId ?? ''),
    accessToken: String(payload.accessToken ?? ''),
  }
}

export const applyAuthSession = (session: ResolvedAuthSession) => {
  const store = useAuthStore.getState()
  store.setLoggedIn(true)
  store.setUserId(session.userId)
  store.setSvrId(session.svrId)
  store.setBrokerId(session.brokerId)
  setWebSocketAuthToken(session.accessToken)
  if (session.accessToken) {
    CfdPush.setSession(session.accessToken)
  } else {
    CfdPush.restoreSession()
  }
}

interface ClearAuthStateOptions {
  clearPushSession?: boolean
}

export const clearAuthState = ({ clearPushSession = true }: ClearAuthStateOptions = {}) => {
  const store = useAuthStore.getState()
  store.setLoggedIn(false)
  store.setUserId('')
  store.setSvrId('')
  store.setBrokerId('')
  store.clearPendingAgreementTypes()
  clearWebSocketAuthToken()
  if (clearPushSession) CfdPush.clearSession()
  clearAccountStatus()
}
